import {
  NBS_API_GET_WHO_IS_ONLINE_RECENT_SUCCESS,
  NBS_API_BLOCK_USER_SUCCESS,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS
} from '../../constants/actions';

const initialState = {
  data: [],
  lastUser: null,
  end: false
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_WHO_IS_ONLINE_RECENT_SUCCESS:
      const currentState = { ...state };
      const { users, end } = action.response;
      const lastUser = end ? null : users[users.length - 1];
      if (action.startOver) {
        return { lastUser, end, data: users };
      } else {
        return { lastUser, end, data: [...currentState.data, ...users] };
      }
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
    case NBS_API_BLOCK_USER_SUCCESS:
      const currentUsers = [...state.data];
      const newUsers = currentUsers.filter(user => user.user_id !== action.userId);
      return { ...state, data: newUsers };
    default:
      return state;
  }
}
